module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HTMLHeader'), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLMenu'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "floating-buttons"
  }, [_c('router-link', {
    staticClass: "fl-button grey",
    attrs: {
      "to": {
        path: '/buildings/'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "fl-button",
    attrs: {
      "disabled": _vm.is_save,
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])], 1), _vm._v(" "), _c('h1', [_vm._v("Épület")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "name",
      "label": "Megnevezés",
      "errors": _vm.errors,
      "name": "name"
    },
    model: {
      value: (_vm.form.building.name),
      callback: function($$v) {
        _vm.$set(_vm.form.building, "name", $$v)
      },
      expression: "form.building.name"
    }
  }), _vm._v(" "), (_vm.form.building.plan_file != '') ? _c('div', {
    staticClass: "form-group"
  }, [_c('img', {
    staticStyle: {
      "width": "200px",
      "height": "auto"
    },
    attrs: {
      "src": _vm.fileSrc,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button with-icon",
    attrs: {
      "disabled": _vm.uploading,
      "type": "button"
    },
    on: {
      "click": _vm.uploadBtnClick
    }
  }, [_c('i', {
    staticClass: "fas fa-upload"
  }), _vm._v("Fájl feltöltése")]), _vm._v(" "), (_vm.form.building.plan_file != '') ? _c('button', {
    staticClass: "button with-icon",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fileDeleteBtnClick
    }
  }, [_c('i', {
    staticClass: "fas fa-trash-alt"
  }), _vm._v("Fájl törlése")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.building.upload_file),
      expression: "form.building.upload_file"
    }],
    staticStyle: {
      "position": "absolute",
      "left": "-10000px"
    },
    attrs: {
      "accept": "image/*",
      "id": "upload_file",
      "type": "file",
      "name": "upload_file"
    },
    domProps: {
      "value": (_vm.form.building.upload_file)
    },
    on: {
      "change": _vm.uploadFile,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form.building, "upload_file", $event.target.value)
      }
    }
  })], 1)])])])], 1), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProgressInfo', {
    attrs: {
      "show": _vm.is_save
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-417bee00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/building.vue
// module id = 297
// module chunks = 0